






import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  name: 'image-element-widget',
})
export default class ImageElementWidget extends Vue {
  @Prop({ type: String, required: true }) alt!: string;
  @Prop({ type: String, required: true }) src!: string;
}
